module.exports = __webpack_public_path__ + "img/serv.62c5b856.svg";